import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetLiveStreamsItemResponseBody } from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseLiveStreamQueryValues = {
  appId: string;
  liveStreamId: string;
};

export const liveStreamQueryKeyFactory: IQueryKeyFactory<
  IUseLiveStreamQueryValues
> = (values) =>
  values && (['liveStream', values.appId, values.liveStreamId] as const);

export const useLiveStreamQuery = (
  values?: IUseLiveStreamQueryValues,
  options?: UseQueryOptions<IApiGetLiveStreamsItemResponseBody, ApiError>,
): UseQueryResult<IApiGetLiveStreamsItemResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: liveStreamQueryKeyFactory(values),
    queryFn: values
      ? () => api.liveStreams.get(values.appId, values.liveStreamId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
